<ng-template #betaBadge>
  <span
    class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide bg-amber-100 text-amber-700"
    >Beta</span
    >
  </ng-template>

  <div
    class="bg-gray-50 min-h-screen flex flex-col lg:flex-row transition-colors duration-300"
    >
    @if (!isMobileView) {
      <aside
        class="fixed lg:sticky top-0 left-0 z-40 w-full lg:w-64 h-screen lg:h-auto bg-white/90 backdrop-blur-lg shadow-xl lg:shadow-sm p-4 lg:p-6 border-r border-gray-200 transition-all duration-300 transform lg:transform-none -translate-x-full lg:translate-x-0"
        [class.translate-x-0]="isNavOpen"
        >
        <div class="flex justify-center items-center mb-6">
          <img
            src="assets/images/cat_logo.png"
            alt="Caribbean Auto Terminal"
            class="h-10 lg:h-12 w-auto cursor-pointer hover:opacity-80 transition-opacity"
            loading="eager"
            (click)="navigateToHome()"
            />
          </div>
          <div class="relative">
          <nav
            #desktopNav
            (scroll)="onNavScroll($event)"
            class="overflow-y-auto max-h-[calc(100vh-150px)] hide-scrollbar"
          >
            <ul class="space-y-2">
              @for (group of navigationGroups; track trackByGroupTitle($index, group)) {
                @if (isGroupVisible(group)) {
                  <li class="pt-4 mt-4 border-t border-gray-200">
                    <p
                      class="text-xs font-semibold text-gray-500 uppercase tracking-wider px-3 mb-2"
                      >
                      {{ group.title }}
                    </p>
                    <ul class="space-y-2">
                      @for (item of group.items; track trackByLabel($index, item)) {
                        <li>
                          @if (item.subItems) {
                            <div>
                              <button
                                (click)="toggleDropdown(item)"
                                (keydown.enter)="toggleDropdown(item)"
                        (keydown.space)="
                          toggleDropdown(item); $event.preventDefault()
                        "
                                type="button"
                                class="flex items-center justify-between w-full text-gray-700 hover:text-red-600 hover:bg-red-50 transition-all duration-200 rounded-lg p-3 border border-transparent hover:border-red-200 group"
                                [attr.aria-expanded]="openedDropdowns[item.label]"
                                attr.aria-controls="submenu-{{ item.label }}"
                        [ngClass]="{
                          'bg-red-50 text-red-600 border-red-200':
                            isActiveLinkDropDown(item.routerLink),
                        }"
                                >
                                <div class="flex items-center gap-3">
                                  @if (item.icon) {
                                    <span
                                      class="w-5 h-5 flex items-center justify-center"
                                      >
                                      <img
                                        [src]="'assets/icons/' + item.icon"
                                        [alt]="item.label + ' icon'"
                                        class="h-full w-full object-contain"
                                        loading="lazy"
                                        onerror="this.style.display = 'none'"
                                        />
                                      </span>
                                    }
                                    <span class="font-medium text-sm lg:text-base">{{
                                      item.label
                                    }}</span>
                                    @if (item.beta) {
                                      <ng-container
                                        *ngTemplateOutlet="betaBadge"
                                      ></ng-container>
                                    }
                                  </div>
                                  <app-dropdown-arrow
                                    [isOpen]="openedDropdowns[item.label]"
                                  ></app-dropdown-arrow>
                                </button>
                                @if (openedDropdowns[item.label]) {
                                  <ul
                                    id="submenu-{{ item.label }}"
                                    class="ml-8 mt-1 space-y-1 transition-all duration-200"
                                    >
                                    @for (
                                      sub of item.subItems; track trackByLabel($index,
                                      sub)) {
                                      <li
                                        >
                                        @if (isItemAuthorized(sub)) {
                                          <a
                                            [routerLink]="sub.routerLink"
                                            routerLinkActive="text-red-600"
                                            [routerLinkActiveOptions]="{ exact: true }"
                                            class="flex items-center gap-2 px-3 py-1.5 text-sm text-gray-600 hover:text-red-600 rounded"
                                            tabindex="0"
                                            >
                                            @if (sub.icon) {
                                              <span
                                                class="w-5 h-5 flex items-center justify-center"
                                                >
                                                <img
                                                  [src]="'assets/icons/' + sub.icon"
                                                  [alt]="sub.label + ' icon'"
                                                  class="h-full w-full object-contain"
                                                  loading="lazy"
                                                  onerror="this.style.display = 'none'"
                                                  />
                                                </span>
                                              }
                                              {{ sub.label }}
                                              @if (sub.beta) {
                                                <ng-container
                                                  *ngTemplateOutlet="betaBadge"
                                                ></ng-container>
                                              }
                                            </a>
                                          } @else if (sub.externalUrl) {
                                            <a
                                              [href]="sub.externalUrl"
                                              target="_blank"
                                              rel="noopener"
                                              class="flex items-center gap-2 px-3 py-1.5 text-sm text-gray-600 hover:text-red-600 rounded cursor-pointer"
                                              tabindex="0"
                                              (click)="$event.stopPropagation()"
                                              >
                                              @if (sub.icon) {
                                                <span
                                                  class="w-5 h-5 flex items-center justify-center"
                                                  >
                                                  <img
                                                    [src]="'assets/icons/' + sub.icon"
                                                    [alt]="sub.label + ' icon'"
                                                    class="h-full w-full object-contain"
                                                    loading="lazy"
                                                    onerror="this.style.display = 'none'"
                                                    />
                                                  </span>
                                                }
                                                {{ sub.label }}
                                                @if (sub.beta) {
                                                  <ng-container
                                                    *ngTemplateOutlet="betaBadge"
                                                  ></ng-container>
                                                }
                                              </a>
                                            } @else if (sub.routerLink) {
                                              <a
                                                [routerLink]="sub.routerLink"
                                                routerLinkActive="text-red-600"
                                                [routerLinkActiveOptions]="{ exact: true }"
                                                class="flex items-center gap-2 px-3 py-1.5 text-sm text-gray-600 hover:text-red-600 rounded"
                                                tabindex="0"
                                                >
                                                @if (sub.icon) {
                                                  <span
                                                    class="w-5 h-5 flex items-center justify-center"
                                                    >
                                                    <img
                                                      [src]="'assets/icons/' + sub.icon"
                                                      [alt]="sub.label + ' icon'"
                                                      class="h-full w-full object-contain"
                                                      loading="lazy"
                                                      onerror="this.style.display = 'none'"
                                                      />
                                                    </span>
                                                  }
                                                  {{ sub.label }}
                                                  @if (sub.beta) {
                                                    <ng-container
                                                      *ngTemplateOutlet="betaBadge"
                                                    ></ng-container>
                                                  }
                                                </a>
                                              }
                                            </li>
                                          }
                                        </ul>
                                      }
                                    </div>
                                  } @else {
                                    @if (item.externalUrl) {
                                      <a
                                        [href]="item.externalUrl"
                                        target="_blank"
                                        rel="noopener"
                                        class="flex items-center gap-3 text-gray-700 hover:text-red-600 hover:bg-red-50 transition-all duration-200 rounded-lg p-3 border border-transparent hover:border-red-200 group"
                                        tabindex="0"
                                        (click)="$event.stopPropagation()"
                                        >
                                        @if (item.icon) {
                                          <span
                                            class="w-5 h-5 flex items-center justify-center"
                                            >
                                            <img
                                              [src]="'assets/icons/' + item.icon"
                                              [alt]="item.label + ' icon'"
                                              class="h-full w-full object-contain"
                                              loading="lazy"
                                              onerror="this.style.display = 'none'"
                                              />
                                            </span>
                                          }
                                          <span class="font-medium text-sm lg:text-base">{{
                                            item.label
                                          }}</span>
                                          @if (item.beta) {
                                            <ng-container
                                              *ngTemplateOutlet="betaBadge"
                                            ></ng-container>
                                          }
                                        </a>
                                      } @else {
                                        <a
                                          [routerLink]="item.routerLink"
                          [ngClass]="{
                            'bg-red-50 text-red-600 border-red-200':
                              isActiveLink(item.routerLink),
                          }"
                                          class="flex items-center gap-3 text-gray-700 hover:text-red-600 hover:bg-red-50 transition-all duration-200 rounded-lg p-3 border border-transparent hover:border-red-200 group"
                                          tabindex="0"
                                          >
                                          @if (item.icon) {
                                            <span
                                              class="w-5 h-5 flex items-center justify-center"
                                              >
                                              <img
                                                [src]="'assets/icons/' + item.icon"
                                                [alt]="item.label + ' icon'"
                                                class="h-full w-full object-contain"
                                                loading="lazy"
                                                onerror="this.style.display = 'none'"
                                                />
                                              </span>
                                            }
                                            <span class="font-medium text-sm lg:text-base">{{
                                              item.label
                                            }}</span>
                                            @if (item.beta) {
                                              <ng-container
                                                *ngTemplateOutlet="betaBadge"
                                              ></ng-container>
                                            }
                                          </a>
                                        }
                                      }
                                    </li>
                                  }
                                </ul>
                              </li>
                            }
                          }
                        </ul>
                      </nav>
                      <div
                        *ngIf="hasMoreNavItems"
                        class="pointer-events-none absolute inset-x-0 bottom-0 h-10 bg-gradient-to-t from-white/95 to-transparent rounded-b-lg"
                      ></div>
                      </div>
                    </aside>
                  } @else {
                    <div class="flex flex-col overflow-hidden bg-white relative">
                      <div
                        class="flex items-center justify-between px-4 py-3 border-b shadow-sm bg-white sticky top-0 z-50"
                        >
                        <img
                          src="assets/images/cat_logo.png"
                          alt="Caribbean Auto Terminal"
                          class="h-8 w-auto"
                          loading="eager"
                          (click)="navigateToHome()"
                          />
                          <button
                            (click)="isNavOpen = !isNavOpen"
                            aria-label="Toggle Navigation"
                            class="text-gray-600 hover:text-red-600 p-2 rounded-full focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-white"
                            [attr.aria-expanded]="isNavOpen"
                            >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-6 w-6"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="1.5"
                              >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
              [attr.d]="
                isNavOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'
              "
                                />
                              </svg>
                            </button>
                          </div>
                          @if (isNavOpen) {
                            <div
                              class="fixed inset-0 bg-black/50 z-30 lg:hidden"
                              (click)="isNavOpen = false"
                            ></div>
                          }
                          <div
                            [class.translate-x-0]="isNavOpen"
                            class="fixed lg:hidden top-16 left-0 z-40 w-64 h-[calc(100vh-64px)] bg-white shadow-xl transform -translate-x-full transition-transform duration-300 ease-in-out border-r border-gray-200"
                            >
                            <nav
                              #mobileNav
                              (scroll)="onNavScroll($event)"
                              class="overflow-y-auto h-full hide-scrollbar px-4 pt-4"
                            >
                              <ul class="space-y-4 pb-6">
                                @for (group of navigationGroups; track trackByGroupTitle($index, group)) {
                                  @if (isGroupVisible(group)) {
                                    <li>
                                      <p
                                        class="text-xs font-semibold text-gray-500 uppercase tracking-wider px-2 mb-2"
                                        >
                                        {{ group.title }}
                                      </p>
                                      <ul class="space-y-2">
                                        @for (item of group.items; track trackByLabel($index, item)) {
                                          <li>
                                            @if (item.subItems) {
                                              <div>
                                                <button
                                                  (click)="toggleDropdown(item)"
                                                  (keydown.enter)="toggleDropdown(item)"
                        (keydown.space)="
                          toggleDropdown(item); $event.preventDefault()
                        "
                                                  class="w-full flex justify-between items-center text-gray-700 hover:text-red-600 hover:bg-red-50 p-3 rounded-lg border border-transparent hover:border-red-200 transition-all focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-white"
                                                  [attr.aria-expanded]="openedDropdowns[item.label]"
                                                  attr.aria-controls="mobile-submenu-{{ item.label }}"
                        [ngClass]="{
                          'bg-red-50 text-red-600 border-red-200':
                            isActiveLinkDropDown(item.routerLink),
                        }"
                                                  >
                                                  <div class="flex items-center gap-3">
                                                    @if (item.icon) {
                                                      <img
                                                        [src]="'assets/icons/' + item.icon"
                                                        class="w-5 h-5 object-contain"
                                                        [alt]="item.label + ' icon'"
                                                        loading="lazy"
                                                        onerror="this.style.display = 'none'"
                                                        />
                                                      }
                                                      <span class="font-medium text-sm">{{
                                                        item.label
                                                      }}</span>
                                                      @if (item.beta) {
                                                        <ng-container
                                                          *ngTemplateOutlet="betaBadge"
                                                        ></ng-container>
                                                      }
                                                    </div>
                                                    <app-dropdown-arrow
                                                      [isOpen]="openedDropdowns[item.label]"
                                                    ></app-dropdown-arrow>
                                                  </button>
                                                  @if (openedDropdowns[item.label]) {
                                                    <ul
                                                      id="mobile-submenu-{{ item.label }}"
                                                      class="ml-6 mt-1 space-y-1 transition-all duration-200"
                                                      >
                                                      @for (
                                                        sub of item.subItems; track trackByLabel($index,
                                                        sub)) {
                                                        <li
                                                          >
                                                          @if (isItemAuthorized(sub)) {
                                                            <a
                                                              [routerLink]="sub.routerLink"
                              [ngClass]="{
                                ' text-red-600': isActiveLink(item.routerLink),
                              }"
                                                              class="flex items-center gap-2 px-3 py-1.5 text-sm text-gray-600 hover:text-red-600 rounded focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-white"
                                                              tabindex="0"
                                                              >
                                                              @if (sub.icon) {
                                                                <img
                                                                  [src]="'assets/icons/' + sub.icon"
                                                                  class="w-4 h-4 object-contain"
                                                                  [alt]="sub.label + ' icon'"
                                                                  loading="lazy"
                                                                  onerror="this.style.display = 'none'"
                                                                  />
                                                                }
                                                                {{ sub.label }}
                                                                @if (sub.beta) {
                                                                  <ng-container
                                                                    *ngTemplateOutlet="betaBadge"
                                                                  ></ng-container>
                                                                }
                                                              </a>
                                                            }
                                                          </li>
                                                        }
                                                      </ul>
                                                    }
                                                  </div>
                                                } @else {
                                                  <a
                                                    [routerLink]="item.routerLink"
                                                    routerLinkActive="bg-red-50 text-red-600 border-red-200"
                                                    class="flex items-center gap-3 text-gray-700 hover:text-red-600 hover:bg-red-50 transition-all duration-200 rounded-lg p-3 border border-transparent hover:border-red-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-white"
                                                    tabindex="0"
                                                    >
                                                    @if (item.icon) {
                                                      <img
                                                        [src]="'assets/icons/' + item.icon"
                                                        class="w-5 h-5 object-contain"
                                                        [alt]="item.label + ' icon'"
                                                        loading="lazy"
                                                        onerror="this.style.display = 'none'"
                                                        />
                                                      }
                                                      <span class="font-medium text-sm">{{
                                                        item.label
                                                      }}</span>
                                                      @if (item.beta) {
                                                        <ng-container
                                                          *ngTemplateOutlet="betaBadge"
                                                        ></ng-container>
                                                      }
                                                    </a>
                                                  }
                                                </li>
                                              }
                                            </ul>
                                          </li>
                                        }
                                      }
                                    </ul>
                                  </nav>
                                <div
                                  *ngIf="hasMoreNavItems"
                                  class="pointer-events-none absolute inset-x-0 bottom-0 h-10 bg-gradient-to-t from-white/95 to-transparent"
                                ></div>
                                </div>
                              </div>
                            }


                            <div class="flex-1 p-4 lg:p-8 flex flex-col h-screen overflow-hidden">
                              <header
                                class="flex justify-between items-center lg:mb-8 mb-4 bg-white p-4 lg:p-5 rounded-lg shadow-sm"
                                >
                                <h1 class="text-lg lg:text-2xl font-bold text-gray-800">
                                  Welcome back, {{ consigneeName }}
                                </h1>
                                <div class="flex items-center space-x-2 lg:space-x-2">
                                  <div class="relative">
                                    <button
                                      class="relative text-gray-600 hover:text-red-600 transition-all p-2 rounded-full focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-white"
                                      aria-label="Notifications"
                                      (click)="toggleNotifications()"
                                      >
                                      @if (hasNotificationsCount) {
                                        <span
                                          class="absolute top-0 right-0 h-2 w-2 rounded-full bg-red-600 ring-2 ring-white"
                                        ></span>
                                      }

                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        >
                                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                                          <path
                                            d="M18.75 9.71v-.705C18.75 5.136 15.726 2 12 2S5.25 5.136 5.25 9.005v.705a4.4 4.4 0 0 1-.692 2.375L3.45 13.81c-1.011 1.575-.239 3.716 1.52 4.214a25.8 25.8 0 0 0 14.06 0c1.759-.498 2.531-2.639 1.52-4.213l-1.108-1.725a4.4 4.4 0 0 1-.693-2.375Z"
                                            />
                                            <path
                                              stroke-linecap="round"
                                              d="M7.5 19c.655 1.748 2.422 3 4.5 3s3.845-1.252 4.5-3M12 6v4"
                                              opacity="0.5"
                                              />
                                            </g>
                                          </svg>
                                        </button>
                                        @if (showNotifications) {
                                          <div
                                            class="absolute right-0 mt-2 w-100 bg-white border border-gray-200 rounded-lg shadow-lg z-50"
                                            (click)="$event.stopPropagation()"
                                            >
                                            <div
                                              class="p-4 border-b border-gray-100 font-semibold text-gray-700 flex items-center"
                                              >
                                              Notifications
                                              @if (notifications.length) {
                                                <button
                                                  class="ml-auto text-xs text-red-500 hover:underline"
                                                  (click)="markAll()"
                                                  >
                                                  Clear all
                                                </button>
                                              }
                                            </div>
                                            <ul class="max-h-72 overflow-y-auto divide-y divide-gray-100">
                                              @for (notification of notifications; track notification; let i = $index) {
                                                <li
                                                  class="p-4 hover:bg-gray-50 cursor-pointer text-sm text-gray-700 flex items-start gap-3"
                                                  [ngClass]="{ 'opacity-60': notification.isRead }"
                                                  >
                                                  <div class="flex-shrink-0 mt-1">
                                                    <span
                                                      class="inline-block w-2 h-2 rounded-full"
                    [ngClass]="
                      notification.isRead ? 'bg-gray-300' : 'bg-red-500'
                    "
                                                      title="Unread"
                                                    ></span>
                                                  </div>
                                                  <div>
                                                    <div class="font-semibold text-base mb-0.5">
                                                      {{ notification.title }}
                                                    </div>
                                                    <div class="text-sm">{{ notification.message }}</div>
                                                    <span class="block text-xs text-gray-400 mt-1">
                                                      {{ notification.createdAt | date: "short" }}
                                                    </span>
                                                  </div>
                                                </li>
                                              }
                                              @if (!notifications || notifications.length === 0) {
                                                <li
                                                  class="p-4 text-gray-400 text-center"
                                                  >
                                                  No notifications
                                                </li>
                                              }
                                            </ul>
                                          </div>
                                        }
                                      </div>

                                      <button
                                        class="text-gray-600 hover:text-red-600 transition-all p-2 rounded-full focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-white"
                                        (click)="openProfile()"
                                        aria-label="Profile"
                                        >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 24 24"
                                          >
                                          <g fill="none" stroke="currentColor" stroke-width="1.5">
                                            <circle cx="12" cy="12" r="3" />
                                            <path
                                              stroke-linecap="round"
                                              d="M3.661 10.64c.473.296.777.802.777 1.36s-.304 1.064-.777 1.36c-.321.203-.529.364-.676.556a2 2 0 0 0-.396 1.479c.052.394.285.798.75 1.605c.467.807.7 1.21 1.015 1.453a2 2 0 0 0 1.479.396c.24-.032.483-.13.819-.308a1.62 1.62 0 0 1 1.567.008c.483.28.77.795.79 1.353c.014.38.05.64.143.863a2 2 0 0 0 1.083 1.083C10.602 22 11.068 22 12 22s1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083c.092-.223.129-.483.143-.863c.02-.558.307-1.074.79-1.353a1.62 1.62 0 0 1 1.567-.008c.336.178.58.276.82.308a2 2 0 0 0 1.478-.396c.315-.242.548-.646 1.014-1.453c.208-.36.369-.639.489-.873m-.81-2.766a1.62 1.62 0 0 1-.777-1.36c0-.559.304-1.065.777-1.362c.321-.202.528-.363.676-.555a2 2 0 0 0 .396-1.479c-.052-.394-.285-.798-.75-1.605c-.467-.807-.7-1.21-1.015-1.453a2 2 0 0 0-1.479-.396c-.24.032-.483.13-.82.308a1.62 1.62 0 0 1-1.566-.008a1.62 1.62 0 0 1-.79-1.353c-.014-.38-.05-.64-.143-.863a2 2 0 0 0-1.083-1.083C13.398 2 12.932 2 12 2s-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083c-.092.223-.129.483-.143.863a1.62 1.62 0 0 1-.79 1.353a1.62 1.62 0 0 1-1.567.008c-.336-.178-.58-.276-.82-.308a2 2 0 0 0-1.478.396C4.04 5.79 3.806 6.193 3.34 7c-.208.36-.369.639-.489.873"
                                              />
                                            </g>
                                          </svg>
                                        </button>
                                        <button
                                          class="text-gray-600 hover:text-red-600 transition-all p-2 rounded-full focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-white"
                                          (click)="logout()"
                                          aria-label="Logout"
                                          >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            >
                                            <g
                                              fill="none"
                                              stroke="currentColor"
                                              stroke-linecap="round"
                                              stroke-width="1.5"
                                              >
                                              <path
                                                stroke-linejoin="round"
                                                d="M2.001 11.999h14m0 0l-3.5-3m3.5 3l-3.5 3"
                                                />
                                                <path
                                                  d="M9.002 7c.012-2.175.109-3.353.877-4.121C10.758 2 12.172 2 15 2h1c2.829 0 4.243 0 5.122.879C22 3.757 22 5.172 22 8v8c0 2.828 0 4.243-.878 5.121c-.769.769-1.947.865-4.122.877M9.002 17c.012 2.175.109 3.353.877 4.121c.641.642 1.568.815 3.121.862"
                                                  />
                                                </g>
                                              </svg>
                                            </button>
                                          </div>
                                        </header>

                                        <div class="flex flex-col flex-1 overflow-hidden">
                                          <div class="flex-1 overflow-y-auto custom-scrollbar">
                                            <router-outlet></router-outlet>
                                          </div>
                                        </div>
                                        <footer class="py-4 text-center text-gray-500 text-sm mt-auto">
                                          <p>
                                            &copy; {{ getYear() }} Caribbean Auto Terminal. All rights reserved.
                                          </p>
                                        </footer>
                                      </div>
                                    </div>
